<template>
    <div>
        <b-form>
            <b-col cols="12" class="d-flex justify-content-end">
                <b-button variant="primary" @click="adicionarItem">
                    +
                </b-button>
            </b-col>

            <b-form-row>
                <b-table responsive class="mt-2" small :items="contratoForm.financeiroContratos" :fields="fields" hover>
                    <template v-slot:cell(tipoValor)="data">
                        <LgFinderPageTipoValor class="mb-2 mt-2"
                            @input="function (item) { setTipoValor(data.item, item) }" v-model="data.item.tipoValor"
                            :prefix="prefix" label=" " />

                    </template>
                    <template v-slot:cell(tipoAlteracao)="data">

                        <LgFinderPageTipoAlteracao class="mb-2 mt-2"
                            @input="function (item) { setTipoAlteracao(data.item, item) }"
                            v-model="data.item.tipoAlteracao" :prefix="prefix" label=" " />
                    </template>



                    <template #cell(valor)="data">
                        <b-form-input style="height: 20px;" v-model="data.item.valor" type="number" min="1"
                            required></b-form-input>
                    </template>


                    <template #cell(valorAntigo)="data">
                        <b-form-input style="height: 20px;" v-model="data.item.valorAntigo" type="number" min="1"
                            required></b-form-input>
                    </template>

                    <template v-slot:cell(dataAutorizacao)="data">
                        <lg-form-date class="mt-2 mb-2" invalidFeedback=" " description=" "
                            v-model="data.item.dataAutorizacao" label=" " />
                    </template>
                    <template v-slot:cell(dataVigencia)="data">
                        <lg-form-date class="mt-2 mb-2" invalidFeedback=" " description=" "
                            v-model="data.item.dataVigencia" label=" " />
                    </template>


                    <template v-slot:cell(observacao)="data">
                        <lg-form-input class="mt-2 mb-2" v-model="data.item.observacao" label=" " description=" " />
                    </template>

                    <template v-slot:cell(situacao)="data">
                        <lg-form-const-select class="mt-2 mb-2" label="" v-model="data.item.situacao"
                            :options="opcoesSituacao" />
                    </template>
                    <template v-slot:cell(acoes)="data">
                        <b-button v-if="!isEditMode" size="sm" pill variant="danger"
                            @click="removerFinanceiro(data.item)">
                            <b-icon icon="trash" />
                        </b-button>
                    </template>
                </b-table>
            </b-form-row>
        </b-form>
    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import LgFinderPageTipoValor from "@/components/Finders/LgFinderPageTipoValor.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFinderPageTipoAlteracao from "@/components/Finders/LgFinderPageTipoAlteracao.vue";

export default {
    name: "FinanceiroContratosForm",
    mixins: [validationMixin],
    components: {
        LgFinderPageTipoValor,
        LgFinderPageTipoAlteracao,
        LgFormDate,
        LgFormInput,
        LgFormConstSelect

    },
    props: {
        prefix: {
            type: String,
            default: ""
        },
        contratoFormProp: {
            type: Object,
            required: true,
        },
        isEditMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            contratoForm: this.contratoFormProp,
            fields: [
                { key: "valorAntigo", label: "Valor Antigo do Contrato", tdClass: "w-10" },

                { key: "valor", label: "Valor do Contrato", tdClass: "w-10" },
                { key: "tipoAlteracao", label: "Tipo de Alteração", tdClass: "w-20" },
                { key: "tipoValor", label: "Tipo de Valor", tdClass: "w-20" },
                { key: "dataAutorizacao", label: "Data Autorização", tdClass: "w-20" },
                { key: "dataVigencia", label: "Data Vigencia", tdClass: "w-20" },

                { key: "observacao", label: "Observação" },
                { key: "situacao", label: "Situação", class: "text-center" },
                { key: "acoes", label: "Ações", class: "text-center" },
            ],
            opcoesSituacao: [
                { value: 1, text: "Ativo" },
                { value: 0, text: "Inativo" },
            ],
        };
    },
    methods: {
        setTipoValor(item, tipo) {
            item.tipoValor = tipo;
        },
        setTipoAlteracao(item, tipo) {
            item.tipoAlteracao = tipo;
        },
        adicionarItem() {
            this.contratoForm.financeiroContratos.push({ valorAntigo: "", tipoValor: {}, tipoAlteracao: {}, valor: "", dataAutorizacao: "", dataVigencia: "", situacao: 1, observacao: "" });
        },
        removerFinanceiro(index) {
            this.contratoForm.financeiroContratos.splice(index, 1);
        },

    },
};
</script>

<style scoped>
.mt-2 {
    margin-top: 0.5rem;
}

.ml-2 {
    margin-left: 0.5rem;
}

.mt-3 {
    margin-top: 1rem;
}
</style>
